const ESIM_EXCLUDED_COUNTRIES = new Set([
  'MR', // Mauritania
  'ET', // Ethiopia
  'CU', // Cuba
  'TL', // Timor-Leste
  'YE', // Yemen
  'MP', // Northern Mariana Islands
  'NR', // Nauru
  'KI', // Kiribati
  'HT', // Haiti
  'NA', // Namibia
  'GQ', // Equatorial Guinea
  'ZW', // Zimbabwe
  'AO', // Angola
  'BI', // Burundi
])

export function isEsimExcludedCountry(countryCode: string): boolean {
  return ESIM_EXCLUDED_COUNTRIES.has(countryCode.toUpperCase())
}
